// GENERATED by scripts/gen-hooks.mjs. Do not edit by hand.
// 3 hooks for backend/onlinePayments.

import { useBackend } from '../useBackend'

/** POST /api/onlinePayments/decideOnlinePayment */
export function useDecideOnlinePayment<T = any>() {
  return useBackend<T>('onlinePayments/decideOnlinePayment')
}

/** POST /api/onlinePayments/getOnlinePayments */
export function useGetOnlinePayments<T = any>() {
  return useBackend<T>('onlinePayments/getOnlinePayments')
}

/** POST /api/onlinePayments/raiseOnlinePayment */
export function useRaiseOnlinePayment<T = any>() {
  return useBackend<T>('onlinePayments/raiseOnlinePayment')
}
